import { ClassName, Icon, IconSvg, Size } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import './DashboardCardIcon.scss';
import { DashboardTheme } from 'containers/dashboard/types/types';

export interface IDashboardCardIconProps {
  svg: IconSvg;
  theme: DashboardTheme;
  className?: ClassName;
}

export default function DashboardCardIcon({ svg, theme, className }: IDashboardCardIconProps) {
  const classes = classNames('dashboard-card-icon', theme, className);

  return (
    <div className={classes}>
      <Icon svg={svg} size={Size.GROW} />
    </div>
  );
}
